import { z } from 'zod';
import { c } from '../contract';

export const persistRouter = c.router(
  {
    initialPageView: {
      summary: 'Save initial page view',
      method: 'POST',
      path: '/initial-page-view',
      body: z.record(z.string(), z.unknown()),
      responses: {
        200: z.literal('ok'),
      },
    },
    searchParams: {
      summary: 'Save search params',
      method: 'POST',
      path: '/search-params',
      body: z.record(z.string(), z.unknown()),
      responses: {
        200: z.literal('ok'),
      },
    },
  },

  { pathPrefix: '/persist' },
);
